import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_BASE || 'https://cbc_dotdesign.dev.localhost/api/v1'

// 設定預設 header
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 添加 authorization interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('api_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 處理響應
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const data = error.response?.data || {}
    return Promise.reject({
      code: data.code || -1,
      message: data.message || error.message || 'Unknown error',
      data: data.data || null,
    })
  }
)

export default {
  // 建立簽署任務
  async createSignTask(payload) {
    return api.post('/sign-integration/tasks', payload)
  },

  // 查詢簽署狀態
  async getSignStatus(taskId) {
    return api.get(`/sign-integration/tasks/${taskId}`)
  },

  // 補跑失敗任務
  async resendFailedTask(taskId) {
    return api.post(`/sign-integration/tasks/${taskId}/resend`)
  },

  // 設定 API token
  setToken(token) {
    localStorage.setItem('api_token', token)
  },

  // 取得 API token
  getToken() {
    return localStorage.getItem('api_token')
  },

  // 清除 token
  clearToken() {
    localStorage.removeItem('api_token')
  },
}
